import React, { useEffect, useState } from "react";
import { Row, Card, Button, Form, Col } from "react-bootstrap";
import { ErrorMessage, Field, Formik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createExpertise, getExpertiseById, updateExpertise } from "../../../../services/ExpertiseService";

const AddExpertise = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [expertiseData, setExpertiseData] = useState({ name: "", sequence: "" });
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (id) {
      fetchExpertiseDetails(id);
    } else {
      setExpertiseData({ name: "", sequence: "" });
      setIsEditing(false);
    }
  }, [id]);

  const fetchExpertiseDetails = async (expertiseId) => {
    try {
      const expertise = await getExpertiseById(expertiseId);
      if (expertise) {
        setExpertiseData(expertise);
        setIsEditing(true);
      }
    } catch (error) {
      console.error("Error fetching expertise details:", error);
    }
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Name is required")
      .matches(/^[a-zA-Z0-9 ]*$/, "Name should not contain special characters"),
      sequence:  Yup.string()
      .required("Sequence is required")
  });


  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const formattedValues = {"name": values.name.toLowerCase(), sequence: values.sequence.toLowerCase()};
      if (isEditing) {
        await updateExpertise(id,formattedValues);
        toast.success("Expertise updated successfully!");
      } else {
        await createExpertise(formattedValues);
        toast.success("Expertise added successfully!");
      }
      resetForm();
      navigate("/settings/expertise"); // Redirect to expertise list after submission
    } catch (error) {
      console.error("Error processing expertise:", error);
      toast.error("Error processing expertise!");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <Formik
        enableReinitialize
        initialValues={expertiseData}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, handleSubmit, setFieldValue, isSubmitting }) => (
          <Form onSubmit={handleSubmit} className="p-4">
            <h4>{isEditing ? "Edit Expertise" : "Add Expertise"}</h4>
            <Card className="p-4">
              <Row className="mb-3">
              <Col>
                    <div className="form-group">
                      <label htmlFor="name">Expertise</label>
                      <Field
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Expertise"
                        value={values.name}
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>

                
                  <Col>
                    <div className="form-group">
                      <label htmlFor="sequence">Sequence</label>
                      <Field
                        type="text"
                        name="sequence"
                        className="form-control"
                        placeholder="Sequence"
                        value={values.sequence}
                      />
                      <ErrorMessage
                        name="sequence"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
              </Row>
              <Row className="mt-3">
                <Col md={3} className="text-start">
                  <Link to="/settings/expertise">
                    <Button variant="danger" size="sm">
                      Cancel
                    </Button>
                  </Link>
                </Col>
                <Col className="text-end me-3">
                  <Button variant="success" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? "Processing..." : isEditing ? "Update" : "Submit"}
                  </Button>
                </Col>
              </Row>
            </Card>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddExpertise;
